import * as React from "react";
import { useSelector } from "react-redux";
import { getOptionsForParentPortfolio } from "~/Redux/portfolios";
import { getItemId, LabeledItem, noneOption } from "../list";
import { inlinePopupSelectTheme, InlinePopupSelectVirt, InlinePopupSelectVirtProps } from "../select";
import { usePortfolioListProps } from "./hooks";

export type PortfolioListProps = Omit<
    InlinePopupSelectVirtProps<LabeledItem, number>,
    "options" | "getItemLabel" | "valueSelector" | "createAction"
> & { excludedPortfolioId?: number };

export const PortfolioList: React.FC<PortfolioListProps> = ({
    excludedPortfolioId,
    theme = inlinePopupSelectTheme.inline,
    ...props
}) => {
    const listProps = usePortfolioListProps({ selectedId: props.value, excludedPortfolioId });
    const options = useSelector(state => getOptionsForParentPortfolio(state, excludedPortfolioId));

    return (
        <InlinePopupSelectVirt
            minWidth={360}
            emptyOption={noneOption}
            valueSelector={getItemId}
            theme={theme}
            options={options}
            {...listProps}
            {...props}
        />
    );
};
